<template>
    <form id="registerform" method="post" @submit.prevent="register" :ref="registerForm">
        <div class="panel panel-default">
            <div class="panel-heading"><h2>User Registration</h2></div>

            <div class="panel-body">

                <div v-if="error" class="alert alert-danger" role="alert">
                    {{error}}
                </div>

                <div v-if="!userRegistrationKey">
                    <div v-if="userStore.config">
                        <p v-html="userStore.config.header" class="alert alert-info"></p>
                    </div>

                    <UserInfo></UserInfo>

                    <div v-if="existingUserRegistrationKey">
                        <div v-if="user.emailConfirmed" class="alert alert-warning">
                            This email account already exists. Click <a v-on:click="continueRegistration()">here</a> to continue the registration.
                        </div>
                        <div v-else class="alert alert-warning">
                            This email account already exists but it was not confirmed. Click <a v-on:click="continueRegistration()">here</a> to receive another confirmation link.
                        </div>
                    </div>
                </div>

                <div v-else>
                    <p class="alert alert-success">
                        Thank you for submitting your request! An email has been sent to {{user.email}}
                    </p>

                    <div class="row col-md-offset-10 margin-right">
                        <a href=".\" class="btn btn-default custom-button pull-right">OK</a>
                    </div>
                </div>
            </div>

            <div v-if="!userRegistrationKey">
                <div class="panel-footer">
                    <div class="row margin-right">
                        <div class="col-md-offset-8">
                            <button v-if="!existingUserRegistrationKey" type="submit" class="btn btn-primary custom-button">Register</button>
                            <a href=".\" class="btn btn-default custom-button pull-right">Cancel</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </form>
</template>

<style scoped>
    h2 {
        display: inline-block;
        margin: 0;
    }

    .custom-button {
        width: 48%;
    }

    .picklist-item-container {
        max-height: 200px;
        overflow-y: auto;
        padding: 0.25rem 1rem 0.25rem;
        margin-left: 0.5rem;
        font-size: 0.9rem;
    }

    .margin-right {
        margin-right: 0.5em;
    }

    .alert-info {
        color: black;
    }

    .alert-danger {
        color: black;
    }

    .alert-warning {
        color: black;
    }

    .alert-success {
        color: black;
    }

</style>

<script setup>

    import { storeToRefs } from 'pinia';
    import { useUserStore } from '@/stores/user.store';
    import UserInfo from '@/userregistration/userinformation.vue';
    import { useLoading } from 'vue-loading-overlay';
    import { useRouter } from 'vue-router';

    const userStore = useUserStore();

    const { userTypes, user, error, adding, editing, userRegistrationKey, existingUserRegistrationKey } = storeToRefs(userStore);

    const router = useRouter();

    const $loading = useLoading();
    
    async function register() {
        const loader = $loading.show({
            //container: registerForm,
            //color: '#000000',
            //loader: 'dots',
            //width: 64,
            //height: 64,
            //backgroundColor: '#ffffff',
            //opacity: 0.5,
            //zIndex: 999
        });

        await userStore.register(user);

        loader.hide();
    }

    function continueRegistration() {

        if (userStore.user.emailConfirmed) {
            router.push({ name: 'confirmation', params: { id: existingUserRegistrationKey.value } })
        }
        else {
            userStore.sendConfirmationLink(existingUserRegistrationKey.value);
        }

    }

    async function load() {

        userStore.clear();

        await userStore.loadConfig();

        await userStore.loadUserConfig();

        userStore.setAddMode(true);
    }

    (async () => {
        await load();
    })();

</script>
